@let seatsByPax = selectedSeatsByPax$ | async;
@let bundlesByPax = selectedBundleCategoriesByPax$ | async;
@let passengers = passengers$ | async;

<ng-template #paxInner let-passenger let-index="index">
  <span class="flex flex--middle">
    <fcom-icon [name]="SvgLibraryIcon.SINGLE_PAX" class="icon-medium" />
    <div class="ms-xsmall-l font-body-1 flex flex--middle font-body-medium" data-hj-suppress data-dd-privacy="hidden">
      <span class="pax-name truncate overflow-hidden" data-hj-suppress data-dd-privacy="hidden"
        >{{ passenger.traveler.firstName }} {{ passenger.traveler.lastName }}</span
      >
      @if (passenger.withInfant) {
        <span class="ps-xxsmall-l"> ({{ 'seatMap.and' | finLocalization }} {{ passenger.withInfantFullName }} ) </span>
      }
      @if (seatsByPax[passenger.id]) {
        <fcom-tag
          class="ms-xsmall-l flex--inline"
          [theme]="!isNewBrand() && passenger.id === activePaxId() ? TagTheme.WHITE : TagTheme.ACTIVE"
          [attr.data-testid]="'seat-number-pax-' + (index + 1)"
        >
          <span [attr.data-testid]="'seat-number-' + passenger.id" class="font-body-small">{{
            seatsByPax[passenger.id]
          }}</span>

          @if (bundlesByPax[passenger.id]?.length > 0) {
            <fcom-icon
              class="ms-xxsmall-l icon-small"
              [name]="getIconForServiceCategory(bundlesByPax[passenger.id][0])"
            />
            <span class="is-vishidden"
              >+ {{ 'ancillaries.' + bundlesByPax[passenger.id][0] + '.extraTitle' | finLocalization }}</span
            >
          }
        </fcom-tag>
      }
    </div>
  </span>
</ng-template>

@if (passengers) {
  <h3 class="font-heading-4 ps-xsmall-b dn-tablet-down font-title-medium">
    {{ 'seatMap.passengersTitle' | finLocalization }}
  </h3>

  <div class="flex flex--wrap dn-mobile ps-medium-b">
    @for (passenger of passengers; track passenger.id; let index = $index) {
      @if (isNewBrand()) {
        <fcom-chip
          class="ms-xsmall-b ms-xsmall-r flex--inline"
          [theme]="passenger.id === activePaxId() ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
          [title]="passenger.traveler.firstName + ' ' + passenger.traveler.lastName"
          [attr.data-testid]="'passenger-chip'"
          [attr.data-pax-id]="passenger.id"
          (tagClicked)="handleClick(passenger.id, index)"
        >
          <div class="ps-xxsmall-y">
            <ng-container *ngTemplateOutlet="paxInner; context: { $implicit: passenger, index }" />
          </div>
        </fcom-chip>
      } @else {
        <button
          class="pax-selector font-body-1 ms-xsmall-y ms-xsmall-r ps-xsmall border rounded-medium flex flex--middle font-body-medium"
          [attr.data-testid]="'passenger-chip'"
          [attr.data-pax-id]="passenger.id"
          [class.active]="passenger.id === activePaxId()"
          (click)="handleClick(passenger.id, index)"
        >
          <ng-container *ngTemplateOutlet="paxInner; context: { $implicit: passenger, index }" />
        </button>
      }
    }
  </div>

  @if (options$ | async; as options) {
    <form [formGroup]="passengerForm" class="dn-tablet-up ps-medium-y">
      <fin-select-input
        class="fill"
        [parentForm]="passengerForm"
        [controlName]="'activeTravelerId'"
        [options]="options"
        [displayMargin]="false"
        [translationPrefix]="'seatMap.passengers'"
        [disableSelectOption]="true"
        [label]="
          'seatMap.passengers.label'
            | finLocalization
              : {
                  selected: passengers.findIndex((p) => p.id === activePaxId()) + 1,
                  total: passengers.length,
                }
        "
        data-hj-suppress
        data-dd-privacy="hidden"
      />
    </form>
  }
}
